import * as React from 'react'
import LazyVideo from 'components/common/LazyVideo'

const VideoLocal = props => (
  <section className="ctnr padding">
    <LazyVideo {...props} />
  </section>
)

export default VideoLocal
